import { ReactFlowProvider } from "@xyflow/react";
import React from "react";
import { JobType } from "../../types/statusTypes";
import LayoutFlow from "./Layout";
import { generateEdges, generateNodes } from "../../helpers/graphRelationshipBuilders";

interface GraphProps {
  jobs: Record<string, JobType>;
}

export default function Graph({ jobs }: GraphProps) {
  const nodes = generateNodes(jobs);
  const edges = generateEdges();
  return (
        // LayoutFlow must be wrapped in ReactFlowProvider to provide context (https://reactflow.dev/learn/troubleshooting#warning-seems-like-you-have-not-used-zustand-provider-as-an-ancestor)
    <ReactFlowProvider>
      <LayoutFlow nodes={nodes} edges={edges} />
    </ReactFlowProvider>
  );
}
